import Tab from "@Components/Tabs/Tab";
import Tabs from "@Components/Tabs/Tabs";
import TabsList from "@Components/Tabs/TabsList";
import config from "@Config/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import axios from "axios";
import { useEffect, useRef } from "react";
import { useLocationContext } from "../../locationContext";
import Map from "../Map";
import styles from "./mapInfoTabs.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
//

// const TABS = [
//   "Nearby Universities",
//   "Bus Station",
//   "Train Station",
//   "Pharmacy",
//   "Groceries",
//   "Shopping",
//   "Restaurant",
//   "Cafes",
// ];

type MapInfoTabsProps = {
  onClick?: () => void;
  isDesktop?: boolean;
  isMapLoaded?: boolean;
  inventory: any;
  tabs: any;
  setTabs: any;
  activeTab: any;
  setActiveTab: any;
  updateTabState: any;
  handleOptionClick: any;
  selectedOption: any;
  insideModal?: boolean;
  isDesktopStreetView?: boolean;
};

const MapInfoTabs = ({
  onClick,
  isDesktop,
  isMapLoaded,
  inventory,
  tabs,
  setTabs,
  activeTab,
  setActiveTab,
  updateTabState,
  handleOptionClick,
  selectedOption,
  insideModal = false,
  isDesktopStreetView = false,
}: MapInfoTabsProps) => {
  const { t } = useTranslationHook();

  const { universities } = useLocationContext();
  // const [tabHeight, setTabHeight] = useState(0);

  // useEffect(() => {
  //   updateTabState(activeTab);
  // }, [universities]);

  const fetchNearbyLocations = async ({ id }: { id: any }) =>
    axios.get(`${config.API_URL}/api/v0/inventories/${id}/nearby_locations`, {
      params: {
        location_types: "university,bus_station,train_station,supermarket,pharmacy,restaurant",
      },
    });
  const scrollHeightRef = useRef<HTMLDivElement | null>(null);
  const getNearbyLocations = async (id: any) => {
    try {
      const { data = [] } = await fetchNearbyLocations({ id });
      const tabsModified = data?.data?.data || [];
      setTabs(tabsModified);
      setActiveTab(tabsModified[0]);
      // updateTabState(tabsModified[0]); // commenting for now, will check
    } catch (error) {
      setTabs([
        {
          name: "University",
          items: universities || [],
        },
      ]);
    }
  };

  useEffect(() => {
    if (inventory?.id) {
      getNearbyLocations(inventory?.id);
    }
  }, []);
  const scrollHeight = scrollHeightRef.current?.offsetTop ?? 600;

  const mobileItems = insideModal ? activeTab?.items : activeTab?.items?.slice(0, 5);

  const activeTabItems = isDesktop ? activeTab?.items : mobileItems;

  return (
    <Tabs defaultValue={activeTab} activeTab={activeTab} setActiveTab={updateTabState}>
      {!isDesktopStreetView && (
        <TabsList className={formatClassNames(styles.tabList, styles.desktop)}>
          {tabs.map((tab: any) => (
            <Tab
              dataTestId={`property-map-${tab.name}`}
              key={tab.name}
              value={tab}
              className={styles.tab}
              withoutBorder
            >
              {t(tab.name)}
            </Tab>
          ))}
        </TabsList>
      )}
      {/* Tab Panel */}
      <div
        className={formatClassNames(styles.tabPanel, isDesktop && styles.desktop)}
        style={
          insideModal ? { height: `calc(100vh - ${scrollHeight + 80}px)`, overflow: "scroll" } : {}
        }
      >
        <div className={formatClassNames(styles.tabPanelContainer, isDesktop && styles.desktop)}>
          {isDesktop && (
            <div
              className={formatClassNames(
                styles.mapDesktop,
                isDesktopStreetView && styles.streetView,
              )}
            >
              <Map
                inventory={inventory}
                isDesktop={isDesktop}
                onOptionClick={handleOptionClick}
                isMapLoaded={isMapLoaded}
              />
            </div>
          )}
          {!isDesktopStreetView && (
            <div
              className={formatClassNames(isDesktop && styles.placesListDesktopContainer)}
              ref={scrollHeightRef}
            >
              {activeTabItems?.map((item: any, idx: number) => (
                <div
                  className={formatClassNames(
                    styles.placesListItem,
                    item?.name === selectedOption?.name && styles.placesListItem_selected,
                  )}
                  key={`${item?.name}-${idx}`}
                  onClick={() => handleOptionClick(item)}
                  role="none"
                >
                  <span
                    data-testid="PlaceListItem-Recommendations"
                    className={formatClassNames(
                      styles.placesListItem_name,
                      isDesktop && styles.desktop,
                    )}
                  >
                    {item.name}
                  </span>
                  <span
                    data-testid="PlaceListItem-Recommendations-Distance"
                    className={styles.placesListItem_distance}
                  >
                    {item.distance}
                  </span>
                </div>
              ))}
              {!isDesktop && onClick && (
                <div
                  className={styles.placesListFooter}
                  onClick={onClick}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      onClick();
                    }
                  }}
                >
                  {t("propertypage.components.mapsectionv2.viewmorenearbyplaces")}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Tabs>
  );
};

export default wrapperHOC(MapInfoTabs, {
  componentName: "MapsInfo-Tabs",
  showForChina: true,
});
